module.exports = __webpack_public_path__ + "img/payments-processed-empty.58c77465.png";